module.exports = __webpack_public_path__ + "be596aee09905254e59a09581c5428c9.MP3";